module.exports = __webpack_public_path__ + "img/EnConstruccion.bc6aee14.jpeg";